var map = {
	"./agency/agency-profile.js": "60e8",
	"./agency/delivery-monitoring.js": "86b6",
	"./agency/driver-assign.js": "f57e",
	"./agency/drop-package.js": "4143",
	"./agency/package-return.js": "b671",
	"./agency/pickup-request.js": "fc20",
	"./agency/re-delivery.js": "9014",
	"./agency/request-delivery.js": "b801",
	"./agency/request-for-delivery.js": "ec32",
	"./agency/shop.js": "0733",
	"./auth/role.js": "0943",
	"./auth/user.js": "9c26",
	"./corporate/branch-profile.js": "0ed3",
	"./corporate/company-profile.js": "a653",
	"./driver/booking-pickup.js": "8e42",
	"./driver/driver-profile.js": "94e3",
	"./driver/transfer.js": "dcb8",
	"./driver/zone.js": "70ee",
	"./finance/bank-profile.js": "e055",
	"./finance/company-compensate.js": "61be",
	"./finance/driver-clear-cash.js": "238d",
	"./finance/driver-compensation.js": "f7eb",
	"./finance/exchange-rate.js": "ed41",
	"./finance/global-driver-fee.js": "7819",
	"./finance/shop-compensation.js": "506f",
	"./finance/transportation-fee.js": "cc07",
	"./finance/transportation-global-fee.js": "d160",
	"./home.js": "3165",
	"./hr/employee-profile.js": "60e9",
	"./hr/position.js": "747f",
	"./inventory/inventory-list.js": "31e5",
	"./inventory/inventory-pending-list.js": "3d55",
	"./inventory/product-category.js": "ad6b",
	"./inventory/product-packaging.js": "2d51",
	"./inventory/product-profile.js": "b736",
	"./inventory/stock-adjustment.js": "af37",
	"./inventory/stock-in.js": "7270",
	"./inventory/uom.js": "d313",
	"./login.js": "8cc5",
	"./notification/notification-history.js": "fa67",
	"./notification/notification-template.js": "12ae",
	"./notification/telegram-message.js": "a99a",
	"./report/cash-collection-by-cashier.js": "c54a",
	"./report/driver-performance.js": "9e99",
	"./report/driver-transaction-summary.js": "4da1",
	"./report/income-statement-detail.js": "400e",
	"./report/shop-compensate-report.js": "ec29",
	"./report/shop-performance.js": "1486",
	"./security/history-log.js": "631a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61d6";